<template>
  <OnClickOutside
    class="relative w-max"
    @trigger="active = false"
  >
    <button
      class="text-muted-900 dark:text-white focus:outline-none font-medium rounded text-sm px-4 py-2.5 text-center inline-flex items-center transition-colors"
      :class="{
        'border border-muted-300 dark:border-muted-600 hover:bg-muted-200 dark:hover:bg-muted-700': outline,
        'bg-blue-700 hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800': !outline,
      }"
      type="button"
      @click="active = !active"
    >
      <slot />
    </button>

    <!-- Dropdown menu -->
    <div
      class="z-10 absolute top-[calc(100%+4px)] right-0 bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-muted-700 border border-muted-300 dark:border-muted-600"
      :class="{ 'hidden': !active }"
    >
      <ul class="py-1 text-sm text-muted-700 dark:text-gray-200">
        <slot name="menu" />
      </ul>
    </div>
  </OnClickOutside>
</template>

<script>
import { OnClickOutside } from '@vueuse/components';

export default {
  name: 'DropdownComponent',
  components: {
    OnClickOutside
  },
  props: {
    outline: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    active: false
  })
};
</script>

<style lang="scss" scoped>

</style>
